import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { LookupItem } from '../../models/appraisal';

@Injectable({
  providedIn: 'root'
})
export class LookupService {
  private lookupCache: { [key: string]: string[] } = {};
  private lookupItemCache: { [key: string]: LookupItem[] } = {};
  constructor(private http: HttpClient) { }

  // Fetch lookup values for a given key from the API
  fetchLookupValues(key: string): Observable<string[]> {
    const apiUrl = `${environment.appraisalApiConfig.baseUrl}/lookup/${key}`;
    return this.http.get<string[]>(apiUrl);
  }

  // Get allowed values: return from cache if available; otherwise, fetch and cache them.
  getAllowedValues(key: string): Observable<string[]> {
    if (this.lookupCache[key]) {
      return of(this.lookupCache[key]);
    } else {
      return this.fetchLookupValues(key).pipe(
        tap(values => this.lookupCache[key] = values)
      );
    }
  }

  fetchLookupItems(key: string): Observable<LookupItem[]> {
    const apiUrl = `${environment.appraisalApiConfig.baseUrl}/lookup/full/${key}`;
    return this.http.get<LookupItem[]>(apiUrl);
  }

  getLookupItems(key: string): Observable<LookupItem[]> {
    const fullKey = 'Lookup' + key;
    if (this.lookupItemCache[fullKey]) {
      return of(this.lookupItemCache[fullKey]);
    }
    return this.fetchLookupItems(key).pipe(
      tap(items => this.lookupItemCache[fullKey] = items)
    );
  }
}
